(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'site',
            url: '/',
            data: {
                authorities: [],
                pageTitle: 'Logowanie do Portalu - VB Leasing'
            },
            views: {
                'index@': {
                    templateUrl: 'app/views/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
